import { render } from "./MegaMenu.vue?vue&type=template&id=d29964f0&scoped=true"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=d29964f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29964f0"]])

export default __exports__